import React from 'react';
import { BathtubIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { DesignRegistrationPanel } from 'common/components';
import { BATHROOM_ELEMENT_BLOCK } from '../../old-bathroom-constants';

type BathroomDesignPanelProps = {
  designRegistrationHref: string;
};

export const BathroomDesignPanel: React.FC<BathroomDesignPanelProps> = ({ designRegistrationHref }) => {
  const { t } = useTranslation();

  return (
    <DesignRegistrationPanel
      structure={{
        panel: {
          content: {
            leftIcon: BathtubIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text'),
          },
          actionBlock: [
            {
              elementBlock: BATHROOM_ELEMENT_BLOCK,
              href: designRegistrationHref,
              label: t('design-panel.button'),
              target: '_blank',
              variant: 'accent',
            },
          ],
        },
        mobilePanel: {
          mobileButton: {
            elementBlock: BATHROOM_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            href: designRegistrationHref,
          },
          content: {
            icon: BathtubIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text') || '',
          },
          actionBlock: [],
        },
      }}
    />
  );
};
